import { getAssert, getElse } from "../../utils/Safe";
import FlumpLayerSymbol from "./FlumpLayerSymbol";

/**
 * TODO - Add description
 */
export default class FlumpMovieSymbol
{
    /**
     * @param {FlumoLibrary} library - Flump library.
     * @param {*} json - JSON object for the movie clip.
     */
    constructor(library, json)
    {
        /** @type {String} */
        this.name = getAssert([json, "id"], "[FlumpMovieSymbol] Cannot find id.");
        /** @type {number} */
        this.frames = 0;
        
        // Safely get these properties.
        let layerData = getAssert([json, "layers"], "[FlumpMovieSymbol] Cannot find layers.");
        let layerCount = getElse([layerData, "length"], 0);

        /** @type {FlumpLayerSymbol[]} */
        this.layers = new Array(layerCount);
        
        for(let i = 0; i < layerCount; i++)
        {
            let layer = new FlumpLayerSymbol(layerData[i]);
            this.layers[i] = layer;
            this.frames = Math.max(layer.frames, this.frames);
        }
        
        /** @type {number} */
        this.frameRate = library.frameRate;
        /** @type {number} */
        this.duration = this.frames / this.frameRate;
    }
    
    /**
     * Cleans up the FlumpMovieSymbol.
     */
    destroy()
    {        
        if (this.layers != null)
        {
            while (this.layers.length > 0)
            {
                this.layers[0].destroy();
                this.layers.shift();
            }
        }

        this.game = null;
    }
}